import { AxiosResponse } from "axios";
import { identity, isArray, mapKeys, pickBy } from "lodash-es";

import { IHttpRequestConfig } from "@/browser";

import { IErrorEntry } from "./types-ensure";

export const getCode = (payload: Partial<IErrorEntry>) => {
  return payload ? payload.code : undefined;
};

export const getFieldCode = (payload: Partial<IErrorEntry>, fieldName: string) => {
  if (!payload) {
    return undefined;
  }

  if (!isArray(payload.errors)) {
    return undefined;
  }

  const field = payload.errors.find(error => error.field === fieldName);

  if (!field) {
    return undefined;
  }

  return field.code;
};

export const hasCode = (payload: Partial<IErrorEntry>, code: string) => {
  return getCode(payload) === code;
};

export const hasFieldCode = (payload: Partial<IErrorEntry>, fieldName: string, code: string) => {
  return getFieldCode(payload, fieldName) === code;
};

export interface IHeaders {
  companyId?: number;
  consultantProfileId?: number;
  recaptchaToken?: string;
  hubspotutk?: string;
}

const mapper: { [key: string]: string } = {
  companyId: "X-Context-Id",
  consultantProfileId: "X-Consultant-Context",
  recaptchaToken: "X-Recaptcha",
};

export const applyHeaders = (headers: IHeaders, options: IHttpRequestConfig = {}) => {
  const mapped = mapKeys(headers, (_v, key) => (mapper[key] ? mapper[key] : key));
  const legit = pickBy(mapped, identity);

  return { ...options, headers: legit };
};

export const extractDataFromResponse = <T>(response: AxiosResponse<T>) => response.data;
